"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginDto = void 0;
const AppDto_1 = require("../apps/AppDto");
class LoginDto {
    constructor(params) {
        this.username = "";
        this.passwordHash = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.username = params.username;
        this.passwordHash = params.passwordHash;
        this.role = params.role;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app === null ?
                null :
                new AppDto_1.AppDto(params.app);
        }
    }
}
exports.LoginDto = LoginDto;
//# sourceMappingURL=LoginDto.js.map